import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Dialog, Box } from '@mui/material';

/** Redux Packages. */
import { useDispatch, useSelector } from 'react-redux';

/** Internal Components. */
import { handleProcessRowUpdate } from 'shared/lib/fetchSocket';
import DialogHeader from 'shared/ui/DialogHeader';
import { PaperComponent } from 'shared/ui/DraggableDialog';
import SingleDatagrid from 'shared/ui/Datagrid';

import { linkCols as truckingLinkCols } from '../TableDefinition/TruckingSubDef';
import { columnConfigMap, notAllowNullKey, dateField } from 'data/shipmentDetailConfig';

export default function LinkDialog({
    linkOpen,
    setLinkOpen,
    cntrRow,
    cntrData,
    presetData,
    matchedTodoContainer,
    containerData,
    tabConfig,
    mainRow,
}) {
    /** Get the dispatch function from Redux to send actions to the store. */
    const dispatch = useDispatch();
    /** Value for shipment type(OIM/OEX/AIM/AEX/Trucking = 0~4). */
    const tabValue = useSelector((state) => state.tabValueForm);
    /** Determine column config dynamically. */
    const linkCols = tabConfig ? columnConfigMap[tabConfig.columns[6]] : tabValue == 4 ? truckingLinkCols : null;

    /** State for link rows in datagrid. */
    const [linkRow, setLinkRow] = useState([]);

    /** Extract row to be edited based on cntrRow. */
    useEffect(() => {
        const filteredRow = cntrData.filter((item) => item.id == cntrRow.id);
        setLinkRow(filteredRow);
    }, [cntrData]);

    /** Close dialog handler. */
    const handleClose = () => setLinkOpen(false);

    return (
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            open={linkOpen}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    borderRadius: '18px',
                },
            }}
            PaperComponent={PaperComponent}
        >
            <Box sx={{ height: 155, display: 'flex', flexDirection: 'column' }}>
                <DialogHeader
                    cursor
                    title={`Link Upload | ${cntrRow.cntr_number || cntrRow.alias || ''}`}
                    onClose={handleClose}
                />
                <Box sx={{ p: 1.5 }}>
                    <SingleDatagrid
                        rows={linkRow}
                        cols={linkCols(presetData, matchedTodoContainer)}
                        processRowUpdate={(newRow) =>
                            handleProcessRowUpdate({
                                dispatch,
                                tabValue,
                                methodTableName: tabConfig ? tabConfig.tableName[2] : 'il_ftl_ltl_alias',
                                reducerName: tabConfig ? tabConfig.updateReducer[2] : 'setBolUpdateData',
                                tableId: tabValue === 4 ? [mainRow.id] : [mainRow.id, newRow[tabConfig.keyName[1]]],
                                formData: containerData,
                                newRow,
                                notAllowNullKey,
                                dateField,
                            })
                        }
                        sx={{ border: '1px solid #f1f1f1', maxHeight: '70px' }}
                    />
                </Box>
            </Box>
        </Dialog>
    );
}
